Highcharts.setOptions({
    lang: {decimalPoint: ',', thousandsSep: '.'},
    chart: {},
    credits: {
        enabled: false
    },
    title: {
        text: null
    },
    subtitle: {
        text: null
    },
    yAxis: {
        title: {
            text: null
        }
    },
});